import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { AppInfoComponent } from './app-info.component';
import { DragDropModule } from '../../drag-drop/drag-drop.module';
import { CommonModule } from '@angular/common';

export const USER_COMPONENTS = [AppInfoComponent];

@NgModule({
  declarations: USER_COMPONENTS,
  imports: [TranslateModule, CommonModule, DragDropModule],
  exports: USER_COMPONENTS,
})
export class AppInfoModule {}
